<template>
  <b-modal ref="ie-payment-transfer-info" hide-footer hide-header>

    <div class="vtd-modal-content">
      <div class="vtd-modal-header mb-1">
        <h5 class="vtd-modal-title">Make a Payment</h5>
        <button
            @click="closeModal('all')"
            type="button"
            class="close"
            aria-label="Close"
            id="close-ie-transfer-modal"
        >
          <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
        </button>
      </div>

      <div class="vtd-modal-body">
        <div class="before-pay-info">
          <div class="row">
            <div class="col">
              <h4>Payment by Bank Transfer</h4>
              <p>If you wish to pay us by direct bank transfer, please find our bank details below.</p>
              <p>Please identify your payment to us by including your
                <strong>Trailfinders Booking Reference</strong> AND your <strong>surname</strong>.</p>

              <p><strong>Bank & Address:</strong><br />
              AIB<br />
              100/101 Grafton Street<br />
              Dublin 2</p>

              <p>Account Name:	<strong>Trailfinders Ireland Ltd.</strong></p>
              <p>IBAN:	<strong>IE85 AIBK 9310 4730 3220 37</strong></p>
              <p>SWIFTBIC:	<strong>AIBKIE2D</strong></p>

              <p>Once you have made your bank transfer, please let your consultant know.</p>

              <div class="d-flex justify-content-center my-4">
                <b-button
                    variant="primary"
                    @click="closeModal('this')"
                >
                  Return to Payment Types
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </b-modal>
</template>

<script>

export default {
  // components: {
  //   closeParent
  // },
  data() {
    return {
      modalToDisplay: 0,
      confirmationCheckBox: "false",
    };
  },
  mounted() {

  },
  methods: {
    async showModal() {
      this.$refs["ie-payment-transfer-info"].show();
    },
    closeModal(_type) {
      this.confirmationCheckBox = "false";
      this.$refs["ie-payment-transfer-info"].hide();
      this.modalToDisplay = 0;
      if(_type==='all') {
        document.querySelector("#close-make-payment-modal").click()
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../styles.scss";
</style>